import { Validation, Messages } from 'utils/forms/validations';

let formHasError = false;

export const validate = (values) => {
  let errors = {};
  let validationResult;
  formHasError = false;

  validationResult = Validation.requiredCheckbox(
    values.reasonFoDecliningApplication,
  );
  if (validationResult) {
    errors.reasonFoDecliningApplication = validationResult;
    formHasError = true;
  }

  if (formHasError) {
    errors._error = Messages.FILL_IN_ALL;
  }

  return errors;
};
